<iframe style="height: calc(100vh - 32px);border: 0;width: 100%;background: white;" [src]="url | safe"></iframe>
